import { render } from "./side_nav.vue?vue&type=template&id=d5fe9638"
import script from "./side_nav.vue?vue&type=script&lang=js"
export * from "./side_nav.vue?vue&type=script&lang=js"

import "./side_nav.vue?vue&type=style&index=0&id=d5fe9638&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__